import { useState } from "react";
import { useInterval } from "react-use";

interface CountdownProps extends React.HTMLAttributes<HTMLSpanElement> {
  targetDate: Date;
  text?: string;
}

export default function CountDownTimer({
  targetDate,
  text,
  ...props
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState<number>(+targetDate - +new Date());

  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    return Math.max(0, difference);
  };

  useInterval(
    () => {
      setTimeLeft(calculateTimeLeft());
    },
    timeLeft > 0 ? 1000 : null,
  );

  const hours = Math.floor(timeLeft / (1000 * 60 * 60))
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((timeLeft / (1000 * 60)) % 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((timeLeft / 1000) % 60)
    .toString()
    .padStart(2, "0");

  return (
    <span {...props}>
      {text}{" "}
      <span className="inline-flex w-16 overflow-visible font-bold">
        {hours}:{minutes}:{seconds}
      </span>
    </span>
  );
}
